import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Clarity from '@microsoft/clarity';

import { UserAccessors, UserSelectors } from '@dtna/dvs-support-dcp-shared-state/lib/selectors/user.selector';
import { routeToGtmNameMap } from '@dtna/dvs-core-dcp-client-constants/lib/constants/routes';

import getRoutePatternFromLocation from '../utils/gtm';
import { useHostSelector } from '../store';

const useClarityWatcher = () => {
  const location = useLocation();
  const user = useHostSelector(UserAccessors.getUserState);
  const userIsSignedIn = useHostSelector(UserSelectors.selectUserIsSignedIn);
  const clarityDisabled = !process.env.REACT_APP_CLARITY_PROJECT_ID || process.env.REACT_APP_CLARITY_PROJECT_ID?.toString?.() === 'false';

  useEffect(() => {
    if (clarityDisabled || !userIsSignedIn || !(user?.Model?.Email)) return;

    const pathPattern = getRoutePatternFromLocation(location.pathname);

    if (!pathPattern) {
      Clarity.identify(user.Model.Email);
      return;
    }

    const pageName = routeToGtmNameMap.get(pathPattern);

    if (!pageName) {
      Clarity.identify(user.Model.Email);
      return;
    }

    Clarity.identify(user.Model.Email, undefined, JSON.stringify(pageName), user.Customer?.Tan);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, userIsSignedIn, user]);
};

export default useClarityWatcher;
